var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1117_155",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.876709,
    width: 24,
    height: 27.1233,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1117_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4217 5.17706C9.92516 4.0397 10.0275 3.12087 10.6947 2.47562C10.9883 2.18958 11.3576 2.02494 11.743 2.00824C12.1284 1.99154 12.5075 2.12375 12.8192 2.38356C13.5601 3.02107 13.6865 3.91065 13.2171 5.13663C13.7271 5.40075 14.2613 5.61927 14.7442 5.93846C16.8303 7.31499 17.9113 9.41764 18.0279 12.1569C18.0783 13.3614 18.1031 14.5659 18.073 15.7703C18.049 16.7847 18.3258 17.6527 18.8253 18.4572C19.2097 19.0766 19.6069 19.6866 19.9688 20.3215C20.3509 20.9917 20.5931 21.7264 20.5999 22.5412C20.6052 23.2742 20.3697 23.6011 19.7416 23.7C19.456 23.7422 19.1682 23.762 18.8802 23.7594C14.1424 23.7628 9.40484 23.7628 4.66752 23.7594C4.40445 23.7609 4.14158 23.7425 3.88063 23.7043C3.23518 23.608 2.96964 23.2191 3.00274 22.4715C3.04562 21.5036 3.40596 20.6794 3.87613 19.9025C4.27483 19.2435 4.69084 18.5965 5.07074 17.9238C5.41152 17.3215 5.53339 16.6427 5.54166 15.9192C5.55821 14.3869 5.49427 12.8375 5.67105 11.3267C6.0171 8.36373 7.53669 6.40217 9.97631 5.36117C10.1155 5.30181 10.2562 5.24503 10.4217 5.17706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 24.3837C13.9861 25.6289 12.974 26.8129 11.8911 26.8677C10.7568 26.9271 9.69413 25.7881 9.59961 24.3837H13.9996Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhNotification);
export default __webpack_public_path__ + "static/media/wh_notification.bf4ecfa00f7a9b30aa6d8cd95dd68f47.svg";
export { ForwardRef as ReactComponent };